module.exports = {"scan":"Please scan QR by Phone!","download":"Download the APP","downloadDes":"App for iOS and Android","title":"AIS Smart CAM Download","mainland":"App Store","international":"Google Play","tips":"Tips:The Chinese mainland edition is only available for users in the Chinese mainland.Non-chinese mainland users please download the International edition."}


//////////////////
// WEBPACK FOOTER
// ./src/common/i18n/app-en.json
// module id = dE3O
// module chunks = 0